import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { Paper, List, ListItemText, ListItem, ListItemAvatar, Avatar, ListItemIcon, CardMedia, Checkbox, IconButton, Box, ListItemButton } from '@mui/material';
import TAGTypography from '../TAGTypography/TAGTypography';
import { EllipsisV, MapMarker } from '../../../assets/images/SVG';
import { ExpandMore } from '@mui/icons-material';
var bgColorFix = {
  '& :hover': {
    backgroundColor: 'rgb(235, 235, 235, 0.54)'
  },
  '& :active': {
    backgroundColor: 'rgb(210, 210, 210, 0.54)'
  }
};

var TAGItem = function TAGItem(_ref) {
  var avatarAltText = _ref.avatarAltText,
      avatarPath = _ref.avatarPath,
      dropdownItems = _ref.dropdownItems,
      endPosition = _ref.endPosition,
      floating = _ref.floating,
      imageAltText = _ref.imageAltText,
      imagePath = _ref.imagePath,
      itemText = _ref.itemText,
      overlineText = _ref.overlineText,
      overlineTextBoolean = _ref.overlineTextBoolean,
      secondaryActionTypography = _ref.secondaryActionTypography,
      secondaryText = _ref.secondaryText,
      secondaryTextBoolean = _ref.secondaryTextBoolean,
      startPosition = _ref.startPosition;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var metaConditionalMargins = !overlineTextBoolean && secondaryTextBoolean ? -2.25 : null;
  var overlineTextConditional = overlineTextBoolean && secondaryTextBoolean && endPosition !== 'Dropdown';
  var dropdownConditional = endPosition === 'Dropdown' && startPosition === 'Nothing' || startPosition === 'Location' && endPosition === 'Dropdown';
  return React.createElement(Paper, {
    sx: {
      '& :hover': {
        backgroundColor: 'neutrals.neutral'
      },
      '& :active': {
        backgroundColor: 'neutrals.primary'
      },
      borderRadius: 0
    },
    elevation: floating ? 2 : 0
  }, React.createElement(List, null, React.createElement(ListItem, {
    sx: {
      borderRadius: 0,
      padding: 2,
      display: overlineTextConditional ? 'flex' : null,
      alignItems: overlineTextConditional ? 'start' : null
    },
    secondaryAction: endPosition === 'Meta' ? React.createElement(Box, {
      sx: {
        mt: overlineTextConditional ? -4.25 : metaConditionalMargins
      }
    }, React.createElement(TAGTypography, {
      variant: "lowestLevel",
      color: "text.secondary"
    }, secondaryActionTypography)) : endPosition === 'Checkbox' ? React.createElement(Box, {
      sx: {
        mt: overlineTextConditional ? -5.25 : null
      }
    }, React.createElement(Checkbox, null)) : endPosition === 'Kebab' ? React.createElement(IconButton, {
      sx: [bgColorFix, {
        mt: overlineTextConditional ? -6.25 : null
      }]
    }, React.createElement(EllipsisV, {
      sx: {
        color: 'text.secondary'
      }
    })) : dropdownConditional ? React.createElement(IconButton, {
      onClick: function onClick() {
        return setOpen(!open);
      },
      sx: bgColorFix
    }, React.createElement(ExpandMore, {
      sx: {
        color: 'text.secondary'
      }
    })) : null
  }, startPosition === 'Avatar' && React.createElement(ListItemAvatar, null, React.createElement(Avatar, {
    alt: avatarAltText,
    src: avatarPath
  })), startPosition === 'Location' && React.createElement(ListItemIcon, {
    sx: {
      mr: -1
    }
  }, React.createElement(MapMarker, {
    sx: {
      color: open ? 'secondary' : 'text.secondary'
    }
  })), (startPosition === 'LargeImg' || startPosition === 'SmallImg') && React.createElement(CardMedia, {
    component: "img",
    image: imagePath,
    alt: imageAltText,
    sx: {
      width: startPosition === 'SmallImg' ? '56px' : '78.29px',
      height: startPosition === 'SmallImg' ? '40.06px' : '56px',
      pr: 2,
      pt: 0.5
    }
  }), React.createElement(ListItemText, {
    primary: React.createElement(React.Fragment, null, overlineTextConditional && React.createElement(TAGTypography, {
      variant: 'overline',
      color: "text.tertiary"
    }, overlineText.toUpperCase()), React.createElement(TAGTypography, {
      variant: 'bodyMediumBook',
      color: "text.secondary"
    }, itemText)),
    secondary: endPosition !== 'Dropdown' && secondaryTextBoolean && React.createElement(TAGTypography, {
      variant: 'bodySmallBook',
      color: "text.tertiary"
    }, secondaryText)
  })), open && endPosition === 'Dropdown' && dropdownItems.map(function (item, index) {
    return React.createElement(ListItemButton, {
      key: item.ddItemText + index,
      sx: bgColorFix
    }, React.createElement(ListItemText, {
      sx: {
        pl: '72px'
      }
    }, item.ddItemText));
  })));
};

export default TAGItem;